export default "__VITE_ASSET__CCQGqVhI__"